import React from 'react'
import PropTypes from 'prop-types'
import TodoTypeSelectList from './todo-type-select-list'

export function TypeSelect(props) {
  const { onChange, ...restProps } = props

  const handleChange = (option) => {
    onChange && onChange(option)
  }

  const options = {
    name: 'type',
    onChange: handleChange,
    ...restProps,
  }

  return (
    <TodoTypeSelectList
      {...options}
    />
  )
}
TypeSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
}
